let version = require('../../package.json').version

export const environment = {
  production: true,
  envName: 'prod',
  traaqrUser: 'madison@traaqr.com',
  traaqrPassword: 'hummus12',
  gitCommit: 'eb8c3eff63909baa636654652ffbdcb18d8be3d4',
  buildNumber: '443',
  release: version,
  driveDeveloperKey: 'AIzaSyBFWsx5cy-GlRx8hC8jiOmuGnPbZuforws',
  stripe_pk: 'pk_live_MZFAy1dQqWDafQ8TECZLn84D',
  schedulesBucket: 'veil-schedules-prod'
};
